export const REFRESH_TOKEN = `mutation refreshToken($token: String!) {
    tokenRefresh(token: $token) {
       payload
       token
     }
   }`;
